import React, {Fragment, useEffect, useState} from 'react';

import Header from '../components/Header'
import Slider from '../components/Slider/home-two'
// import HomeSlider3 from '../components/Slider/home-three'
import About from '../components/About/home-two'
import Services from '../components/Services'
import HomeNews from "../components/HomeNews/home-two";
import Blog from "../components/Blog";
import BrandLogo from "../components/BrandLogo";
import Footer from "../components/Footer";
import {useHomeSlideShow} from './../queries/homeSlideShow';
import {useNewsList} from './../queries/news';
import { Query} from "@apollo/client";
import ToolBarMenu from './../components/ToolBarMenu/index';
import SelectedHVProducts from '../templates/SelectedHVProducts/index';
import SelectedMVProducts from './../templates/SelectedMVProducts/index';
import InfinitProgressBar from '../components/InfiniteProgressBar';
import MobileMenu from "../components/MobileMenu";

const HomeTwo = () => {

    const [MenuItemsList, setMenuItemsList] = useState([]);
    const dataSlide = useHomeSlideShow();
    const dataNews = useNewsList();
    
    
    if(dataSlide.loading) return <InfinitProgressBar/>
    if(dataSlide.error) return <div>error!</div>

    if(dataNews.loading) return <InfinitProgressBar/>
    if(dataNews.error) return <div>error!</div>
   


    return (
        <Fragment>
            {/* <ToolBarMenu/> */}
            <Header/>
            <Slider slideData={dataSlide}/>
            <SelectedHVProducts title="محصولات فشار قوی" />
            <SelectedMVProducts title="محصولات فشار متوسط"/>
            <About/>
            <Services/>
            {/* <Features classes="sp-top"/> */}
            {/* <Testimonial/> */}
            <br/>
            <br/>
            <br/>
            <HomeNews newsData={dataNews}/>
            <Blog/>
            <BrandLogo/>
            <br/>
            <br/>
            <br/>
            {/* <Funfact/> */}
            {/* <CallToAction/> */}
            <Footer/>
            {/* <LoginRegister/>*/}
            <MobileMenu isSided={true}/> 
        </Fragment>
    );
};

export default HomeTwo;